import { CommonModule, registerLocaleData } from "@angular/common";
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  //HttpClientModule,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { LOCALE_ID, NgModule } from "@angular/core";

import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from "@ngx-translate/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { AuthInterceptor } from "./core/interceptors/auth.interceptor";
import { ErrorInterceptor } from "./core/interceptors/error.interceptor";
import { MultiTranslateHttpLoader } from "./core/loaders/multi-translate-http.loader";
import { FooterComponent } from "./shared/components/footer/footer.component";
import { HeaderComponent } from "./shared/components/header/header.component";
import { PageNotFoundComponent } from "./shared/components/page-not-found/page-not-found.component";
import { SharedModule } from "./shared/shared.module";

import { FormsModule } from "@angular/forms";
import { MainLayoutComponent } from "./shared/layouts/main-layout/main-layout.component";
import { SubLayoutComponent } from "./shared/layouts/sub-layout/sub-layout.component";
import { MatTooltipModule } from "@angular/material/tooltip";
//ag-grid-import
import localeVi from "@angular/common/locales/vi";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import { HomeModule } from "./features/home/home.module";
import { LoadingComponent } from "./shared/components/loading/loading.component";
import { MatExpansionModule } from "@angular/material/expansion";

import { LoadingInterceptor } from "./shared/interceptor/loading.interceptor";
import { FloatingConsultComponent } from "./shared/components/floating-consult/floating-consult.component";
import { RegistrationPolicyComponent } from './features/policy/pages/registration-policy/registration-policy.component';
import { InfoPrivacyPolicyComponent } from './features/policy/pages/info-privacy-policy/info-privacy-policy.component';
import { DisputeResolutionComponent } from './features/policy/pages/dispute-resolution/dispute-resolution.component';

registerLocaleData(localeVi);

ModuleRegistry.registerModules([AllCommunityModule]);

export function createTranslateLoader(http: HttpClient) {
  return new MultiTranslateHttpLoader(http, "./assets/i18n/", ".json", [
    "auth",
    "common",
    "errors",
  ]);
}

export class CustomMissingTranslationHandler
  implements MissingTranslationHandler
{
  handle(params: MissingTranslationHandlerParams) {
    console.warn(
      `[i18n] Missing translation for key: '${params.key}' in '${params.translateService.currentLang}'`
    );
    return `{{${params.key}}}`;
  }
}

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    //HomeComponent,
    HeaderComponent,
    FooterComponent,
    MainLayoutComponent,
    SubLayoutComponent,
    LoadingComponent,
    RegistrationPolicyComponent,
    InfoPrivacyPolicyComponent,
    DisputeResolutionComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    HomeModule,
    MatExpansionModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    MatIconModule,
    MatMenuModule,
    MatButtonModule,
    MatTooltipModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
      // Không nên fix cứng defaultLanguage ở đây nếu muốn dùng localStorage linh hoạt
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: CustomMissingTranslationHandler,
      },
      isolate: false,
    }),
    FloatingConsultComponent
],
  providers: [

    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
    {
      provide: LOCALE_ID,
      useValue: "vi",
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {
  constructor(private translate: TranslateService) {
    translate.addLangs(["en", "vi"]);
  }
}
